import Component from "vue-class-component";
import Vue from "vue";
import {ScaleConnection} from "@/components/properties/settings/scale/ScaleConnection";
import {PacketSizeConfiguration} from "@/components/properties/settings/scale/PacketSizeConfiguration";
import PropertyField from "@/components/properties/PropertyField.vue";
import {ScaleRequestMode} from "@/components/properties/settings/scale/ScaleRequestMode";
import {ScaleProperties} from "@/components/properties/settings/scale/ScaleProperties";
import {ScaleStopBits} from "@/components/properties/settings/scale/ScaleStopBits";
import {ScaleParity} from "@/components/properties/settings/scale/ScaleParity";

@Component({
  components: {PropertyField},
  computed: {
    ScaleStopBits() {
      return ScaleStopBits;
    },
    ScaleProperties() {
      return ScaleProperties;
    },
    ScaleRequestMode() {
      return ScaleRequestMode;
    },
    ScaleConnection() {
      return ScaleConnection;
    },
    PacketSizeConfiguration() {
      return PacketSizeConfiguration;
    },
    ScaleParity() {
      return ScaleParity;
    }
  },
})
export default class ScaleView extends Vue {
  public loading: boolean = false;
  public loadingError: boolean = false;
  public scaleConnectionMode: ScaleConnection = ScaleConnection.SERIAL;
  public scaleRequestMode: string = "Request";
  public allSpecialSymbols: string[] = ['␂', '␃', '␍', '␊'];
  public packetSizeConfiguration: string = PacketSizeConfiguration.PACKET_SIZE;
  public stepsModel: string = '1';
  public isScaleEnabled: boolean = true;

  public updateScaleEnabled(isEnabled: any) {
    this.isScaleEnabled = isEnabled === true || isEnabled === "true";
  }

  public updateScaleConnectionMode(newMode: ScaleConnection) {
    this.scaleConnectionMode = newMode;
  }

  public updatePacketSizeConfiguration(newPacketSizeConfiguration: PacketSizeConfiguration) {
    this.packetSizeConfiguration = newPacketSizeConfiguration;
  }

  public updateScaleRequestMode(newScaleRequestMode: ScaleRequestMode) {
    this.scaleRequestMode = newScaleRequestMode;
  }

  public validateAddress(value: string): string | boolean {
    const addressPattern: string = '([\\d]{1,3}\\.[\\d]{1,3}\\.[\\d]{1,3}\\.[\\d]{1,3}):([\\d]{1,5})';
    const regex = new RegExp(addressPattern);
    const isValidAddress = regex.test(value);
    if (isValidAddress) {
      return true;
    }

    return 'Invalid address. Example: 127.0.0.1:63001';
  }

  public validateWordLength(wordLength: number): string | boolean {

    if (wordLength < 5 || wordLength > 8) {
      return 'Only values from 5 to 8 are supported';
    }

    return true;
  }
}
